// @core/api/endpoints/subscription/delete_subscription_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Remove subscription item
 * Removes a line item from the subscription. Cannot remove the base plan item.
 */
export async function DeleteSubscriptionItem(
  subscription_id: string,
  item_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/items/:item_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
